<template>
  <svg class="k-icon">
    <use :xlink:href="`#i-${name}`"></use>
  </svg>
</template>

<script>
import '../../svg'
export default {
    name:"KilokIcon",
    props:['name']
};
</script>

<style>
.k-icon {
  width: 1em;
  height: 1em;
  margin: 1px;

}
</style>
